﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class OperationalContextClientConfiguration {
    static init(baseUrl, readTokenFn) {
        this.operationalContextBaseUrl = baseUrl;
        this.readTokenFn = readTokenFn;
    }
    static getBaseUrl() {
        return this.operationalContextBaseUrl;
    }
    static getToken() {
        return this.readTokenFn();
    }
}
exports.OperationalContextClientConfiguration = OperationalContextClientConfiguration;
//# sourceMappingURL=OperationalContextClientConfiguration.js.map